<template>
	<div class="page-content">
		
		<kyaneos-header />

		<div class="main-name">
			<!-- PREFIX -->
			<p class="main-name__upper title-segment">Évaluation</p>
		</div>

		<el-title :index="1">
			Les logements
		</el-title>

		<div class="comment">
			<el-textarea
				class="detail-site"
				:parent_data="active_study.etudeData.scpi.evaluation"
				property="commentaire_logements"
				:editable="true"
				placeholder="Commentaire"
				:height="'60px'"
				overflow_edit='hidden scroll'
				text_align="justify"
			/>
		</div>

		<div class="q-mb-sm">
			<div class="box-edit lefter left globale-box" v-show="editor.mode == 'editing'">
				<p>GLOBALE</p>
				<div class="box-edit-line">
					<label>Valeur métrique</label>
					<div class="flex">
						<el-textarea
						:parent_data="logements"
						property="valeur_metrique_globale"
						:editable="true"
						format="number"
						placeholder="ex: 1000"
						style="flex: 4 auto"
						class="q-mr-sm"
						/>
						<div style="flex: 1"> €/m² </div>
					</div>
				</div>
				<div class="box-edit-line">
					<label>Abattement pour occupation</label>
					<div class="flex">
						<el-textarea
						:parent_data="logements"
						property="abattement_occupation_globale"
						:editable="true"
						format="number"
						placeholder="ex: 10"
						style="flex: 4 auto"
						class="q-mr-sm"
						/>
						<div style="flex: 1"> % </div>
					</div>
				</div>
			</div>

			<el-table
				:key="logements.key"
				:table="table_logements"
				:lines-obj="active_study.etudeData.scpi.evaluation"
				lines-field="logements"
				lines-box-class="lefter left top"
				:nb-lines-max="filteredLots.length.toString()"
			/>
			<p v-if="table_overflow">Ce tableau n'intègre qu'un échantillon. Retrouvez l'intégralité des {{ this.active_study.etudeData.kyaneosData.Lots.length }} lots en annexe</p>
		</div>

		<template v-if="show_annexes">

			<el-title :index="2">
				Annexe
			</el-title>

			<el-checkbox
				v-if="editor.mode === 'editing'"
				:parent_data="active_study.etudeData.scpi.evaluation"
				property="show_annexes_commentaire"
				label="Afficher le commentaire"
				:editable="true"
				class="q-mt-md"
			/>

			<div v-if="active_study.etudeData.scpi.evaluation.show_annexes_commentaire" class="comment">
				<el-textarea
					class="detail-site"
					:parent_data="active_study.etudeData.scpi.evaluation"
					property="commentaire_annexe"
					:editable="true"
					placeholder="Commentaire"
					:height="'60px'"
					overflow_edit='hidden scroll'
					text_align="justify"
				/>
			</div>

			<el-checkbox
				v-if="editor.mode === 'editing'"
				:parent_data="active_study.etudeData.scpi.evaluation"
				property="show_annexes_garages"
				label="Afficher le tableau des garages"
				:editable="true"
				class="q-mt-md"
			/>

			<div v-if="active_study.etudeData.scpi.evaluation.show_annexes_garages" class="q-mb-sm evaluation-mx">
				<p class="label main_color_text">Garages</p>
				<el-table
					:table="table_garages"
					:lines-obj="active_study.etudeData.scpi.evaluation"
					lines-field="annexes_table_garages_nb_lignes"
					lines-box-class="left toper"
				/>
			</div>

			<el-checkbox
				v-if="editor.mode === 'editing'"
				:parent_data="active_study.etudeData.scpi.evaluation"
				property="show_annexes_locaux_commerciaux"
				label="Afficher le tableau de locaux commerciaux"
				:editable="true"
				class="q-mt-md"
			/>

			<div v-if="active_study.etudeData.scpi.evaluation.show_annexes_locaux_commerciaux" class="q-mb-sm evaluation-mx">
				<p class="label main_color_text">Locaux commerciaux</p>
				<el-table
					:table="table_locaux_commerciaux"
					:lines-obj="active_study.etudeData.scpi.evaluation"
					lines-field="annexes_table_locaux_commerciaux_nb_lignes"
					lines-box-class="left toper"
				/>
			</div>

			<el-checkbox
				v-if="editor.mode === 'editing'"
				:parent_data="active_study.etudeData.scpi.evaluation"
				property="show_annexes_bureaux"
				label="Afficher le tableau des bureaux"
				:editable="true"
				class="q-mt-md"
			/>

			<div v-if="active_study.etudeData.scpi.evaluation.show_annexes_bureaux" class="q-mb-sm evaluation-mx">
				<p class="label main_color_text">Bureaux</p>
				<el-table
					:table="table_bureaux"
					:lines-obj="active_study.etudeData.scpi.evaluation"
					lines-field="annexes_table_bureaux_nb_lignes"
					lines-box-class="left toper"
				/>
			</div>

		</template>
	</div>
</template>

<script>
import { mapGetters } from "vuex";
import PageMixin from "@/components/study/editor/pages/page.mixin.js";
import KyaneosHeader from "@/components/study/editor/elements/parts/kyaneos-header";

export default {
	components: { KyaneosHeader },
	name: "page-kyaneos-6",
	mixins: [ PageMixin ],
	data: () => ({
		logements: {
			valeur_metrique_globale: "",
			abattement_occupation_globale: "",
			key: 0,
		}
	}),
	props: [ "index" ],
	computed: {
		...mapGetters([ "active_project", "active_study", "editor" ]),
		show_annexes () {
			return this.editor.mode === "editing" || this.active_study.etudeData.scpi.evaluation.show_annexes_commentaire || this.active_study.etudeData.scpi.evaluation.show_annexes_garages || this.active_study.etudeData.scpi.evaluation.show_annexes_locaux_commerciaux || this.active_study.etudeData.scpi.evaluation.show_annexes_bureaux;
		},
		filteredLots () {

			return this.active_study.etudeData.kyaneosData.Lots.filter(lot => lot.TypeBail.toLowerCase().includes("habitation"));
		},
		table_logements: function () {
			const table = {
				head: [],
				body: [],
				config: {
					cols_width: [9, 5, 8, 19, 12, 5, 15, 10, 10, 7],
				},
			};

			table.head.push([
				"Code",
				"Type",
				"Surf. hab.",
				"Type Bail",
				"Loyer",
				"Etat locatif",
				"Ratio locatif",
				"Abattement pour occupation",
				"Valeur métrique",
				"Valeur retenue"
			]);

			const max_row_table = this.active_study.etudeData.scpi.evaluation.logements;
			const calculs = [];
			const indexMax = this.table_overflow ? max_row_table - 1 : max_row_table;
			this.filteredLots.forEach((lot, index) => {
				const ratio = (lot.Loyer / lot.Surface).toFixed(2);

				const retenue = (lot.Surface * lot.valeur_metrique * (1 - lot.abattement_occupation / 100)).toFixed(2);

				calculs[index] = {
					ratio,
					retenue
				};
				if(index < indexMax){
					table.body.push([
						{
							parent_data: lot,
							property: "Code",
							editable: true,
						},
						{
							parent_data: lot.TypeLogement,
							property: "Libelle",
							editable: true,
						},
						{
							parent_data: lot,
							property: "Surface",
							editable: true,
							suffix: "m²"
						},
						{
							parent_data: lot,
							property: "TypeBail",
							editable: true,
						},
						{
							parent_data: lot,
							property: "Loyer",
							editable: true,
							suffix: "€"
						},
						{
							parent_data: lot,
							property: "EtatLocatif",
							editable: true
						},
						{
							value: isNaN(ratio) || !isFinite(ratio) ? "-" : ratio,
							suffix: "€/m²"
						},
						{
							parent_data: lot,
							property: "abattement_occupation",
							editable: true,
							suffix: "%"
						},
						{
							parent_data: lot,
							property: "valeur_metrique",
							editable: true,
							suffix: "€/m²"
						},
						{
							value: isNaN(retenue) || !isFinite(retenue) ? "-" : retenue,
							editable: true,
							suffix: "€"
						},
					]);
				}
			});
			if(this.table_overflow){
				table.body.push([
					{
						value: ". . ."
					},
					{
						value: ". . ."
					},
					{
						value: ". . ."
					},
					{
						value: ". . ."
					},
					{
						value: ". . ."
					},
					{
						value: ". . ."
					},
					{
						value: ". . ."
					},
					{
						value: ". . ."
					},
					{
						value: ". . ."
					},
					{
						value: ". . ."
					}
				]);
			}
			table.body.push([
				{
					value: `TOTAL (${this.filteredLots.length} lgts)`,
					bg_color: "gray",
				},
				{
					value: " ",
					bg_color: "gray",
				},
				{
					value: " ",
					bg_color: "gray",
				},
				{
					value: " ",
					bg_color: "gray",
				},
				{
					value: " ",
					bg_color: "gray",
				},
				{
					value: " ",
					bg_color: "gray",
				},
				{
					value: " ",
					bg_color: "gray",
				},
				{
					value: " ",
					bg_color: "gray",
				},
				{
					value: " ",
					bg_color: "gray",
				},
				{
					value: this.filteredLots.reduce((acc, lot, index) => acc + (+calculs[index].retenue || 0), 0).toFixed(2),
					suffix: "€",
					bg_color: "gray",
				},
			]);

			return table;
		},
		table_overflow: function () {
			return this.filteredLots.length > this.active_study.etudeData.scpi.evaluation.logements;
		},
		table_garages: function () {
			const table = {
				head: [],
				body: [],
				config: {
					cols_width: [40, 30, 30],
				},
			};

			table.head.push(["Nombre de lots", "Valeur unitaire", "Total"]);

			for (let i = 0; i < this.active_study.etudeData.scpi.evaluation.annexes_table_garages_nb_lignes; i++) {
				const loc = this.active_study.etudeData.scpi.evaluation.annexes_table_garages[i];

				const calcul = (parseFloat(loc.nb_lots) * parseFloat(loc.valeur_unitaire)).toFixed(2);

				table.body.push([
					{
						parent_data: loc,
						property: "nb_lots",
						editable: true,
						format: "number"
					},
					{
						parent_data: loc,
						property: "valeur_unitaire",
						editable: true,
						suffix: "€",
						format: "number"
					},
					{
						value: isNaN(calcul) || !isFinite(calcul) ? "-" : calcul,
						suffix: "€",
						format: "number"
					}
				]);
			}

			return table;
		},
		table_locaux_commerciaux: function () {
			const table = {
				head: [],
				body: [],
				config: {
					cols_width: [40, 30, 30],
				},
			};

			table.head.push(["Revenus locatifs annuels", "Taux de rendement retenu", "Valeur"]);

			for (let i = 0; i < this.active_study.etudeData.scpi.evaluation.annexes_table_locaux_commerciaux_nb_lignes; i++) {
				const loc = this.active_study.etudeData.scpi.evaluation.annexes_table_locaux_commerciaux[i];

				const calcul = (parseFloat(loc.revenus) / parseFloat(loc.rendement)).toFixed(2) * 100;

				table.body.push([
					{
						parent_data: loc,
						property: "revenus",
						editable: true,
						format: "number"
					},
					{
						parent_data: loc,
						property: "rendement",
						editable: true,
						suffix: "%",
						format: "number"
					},
					{
						value: isNaN(calcul) || !isFinite(calcul) ? "-" : calcul,
						suffix: "€",
						format: "number"
					}
				]);
			}

			return table;
		},
		table_bureaux: function () {
			const table = {
				head: [],
				body: [],
				config: {
					cols_width: [40, 30, 30],
				},
			};

			table.head.push(["Revenus locatifs annuels", "Taux de rendement retenu", "Valeur"]);

			for (let i = 0; i < this.active_study.etudeData.scpi.evaluation.annexes_table_bureaux_nb_lignes; i++) {
				const loc = this.active_study.etudeData.scpi.evaluation.annexes_table_bureaux[i];

				const calcul = (parseFloat(loc.revenus) / parseFloat(loc.rendement)).toFixed(2) * 100;

				table.body.push([
					{
						parent_data: loc,
						property: "revenus",
						editable: true,
						format: "number"
					},
					{
						parent_data: loc,
						property: "rendement",
						editable: true,
						suffix: "%",
						format: "number"
					},
					{
						value: isNaN(calcul) || !isFinite(calcul) ? "-" : calcul,
						suffix: "€",
						format: "number"
					}
				]);
			}

			return table;
		}
	},
	watch: {
		"logements.valeur_metrique_globale" (val) {
			this.active_study.etudeData.kyaneosData.Lots.forEach((lot, index) => {
				this.$store.dispatch("edit_object", {
					obj: this.active_study.etudeData.kyaneosData.Lots[index], // this.obj,
					field: "valeur_metrique", // this.field,
					value: val,
				});
			});
			this.logements.key++;
		},
		"logements.abattement_occupation_globale" (val) {
			this.active_study.etudeData.kyaneosData.Lots.forEach((lot, index) => {
				this.$store.dispatch("edit_object", {
					obj: this.active_study.etudeData.kyaneosData.Lots[index], // this.obj,
					field: "abattement_occupation", // this.field,
					value: val,
				});
			});
			this.logements.key++;
		}
	},
	mounted: function () {
		const lot_first = this.active_study.etudeData.kyaneosData.Lots[0];
		if(!lot_first.hasOwnProperty("abattement_occupation")){
			this.logements.abattement_occupation_globale = 0;
		}
		if(!lot_first.hasOwnProperty("valeur_metrique")){
			this.logements.valeur_metrique_globale = 0;
		}
	},
};
</script>

<style lang="stylus" scoped>
@import '../../../../assets/css/app'
@import '../../../../assets/css/page'
@import '../../../../assets/css/kyaneos'

.globale-box{
	top: 96px
}
</style>